import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromScheduledReports from '../reducers/scheduled-reports.reducer';
import { getVehicleGroupFilterId } from './vehicle-group.selectors';

export const getScheduledReportsState =
  createFeatureSelector<fromScheduledReports.State>(
    fromScheduledReports.scheduledReportsFeatureKey,
  );

export const getSelectedReportType = createSelector(
  getScheduledReportsState,
  fromScheduledReports.getSelectedReportType,
);
export const getScheduleReportError = createSelector(
  getScheduledReportsState,
  fromScheduledReports.getScheduleReportError,
);
export const getScheduleFilters = createSelector(
  getScheduledReportsState,
  fromScheduledReports.getScheduleFilters,
);

export const getAllSchedules = createSelector(
  getScheduledReportsState,
  fromScheduledReports.selectAll,
);

export const getScheduledReportsLoading = createSelector(
  getScheduledReportsState,
  fromScheduledReports.getScheduledReportsLoading,
);
export const getSchedules = createSelector(
  getAllSchedules,
  getSelectedReportType,
  getVehicleGroupFilterId,
  getScheduleFilters,
  (schedules, reportType, groupId, filters) => {
    schedules = filterScheduledReports(schedules, filters);
    if (groupId !== -1) {
      schedules = schedules.filter(
        (schedule) => schedule.vehicleGroup === groupId,
      );
    }
    if (reportType !== 'all') {
      schedules = schedules.filter(
        (schedule) => schedule.reportType === reportType,
      );
    }

    return schedules;
  },
);

export const getSchedulesByReportType = (reportType: string) => {
  return createSelector(getSchedules, (schedules) => {
    return schedules.filter((schedule) => schedule.reportType === reportType);
  });
};

const filterScheduledReports = (schedules: any, filters: any) => {
  if (filters.length) {
    const periodFilter = filters.filter((i: any) => i.type === 'period');
    const stateFilter = filters.filter((i: any) => i.type === 'status');
    if (periodFilter.length) {
      schedules = schedules.filter((schedule: any) =>
        periodFilter.map((i: any) => i.name).includes(schedule.period),
      );
    }

    if (stateFilter.length && stateFilter.length !== 2) {
      schedules = schedules.filter((schedule: any) =>
        stateFilter[0].name === 'subscribed'
          ? schedule.enabled
          : !schedule.enabled,
      );
    }
  }

  return schedules;
};
